import { SRGBColorSpace, TextureLoader, type Texture } from 'three';
import { canvasTexture } from '../../render/materials/canvasTexture';

const loader = new TextureLoader();
const cache = new Map<string, Texture>();
/** Booked pictures, loaded when their board comes up and dropped a while after (keeps phone memory flat). */
const creatives = new Map<string, { texture: Texture; lastUsed: number }>();
const IDLE_MS = 20_000;

/** A booked ad's image. Same-origin paths (/ads/…) or https URLs that allow CORS. */
export function creativeTexture(url: string): Texture {
  let entry = creatives.get(url);
  if (!entry) {
    const texture = loader.load(url);
    texture.colorSpace = SRGBColorSpace;
    texture.anisotropy = 8;
    entry = { texture, lastUsed: 0 };
    creatives.set(url, entry);
  }
  entry.lastUsed = performance.now();
  return entry.texture;
}

/** Frees pictures no board has shown for a while. The browser keeps the file cached, so a reload is quick. */
export function dropIdleCreatives(now = performance.now()): void {
  for (const [url, entry] of creatives) {
    if (now - entry.lastUsed < IDLE_MS) continue;
    entry.texture.dispose();
    creatives.delete(url);
  }
}

/** Shown in a slot nobody has booked yet. */
export function vacantTexture(area: string): Texture {
  const key = `vacant:${area}`;
  let texture = cache.get(key);
  if (!texture) {
    texture = canvasTexture(1024, 342, (ctx) => {
      ctx.fillStyle = '#f4f1ea';
      ctx.fillRect(0, 0, 1024, 342);
      ctx.fillStyle = '#006b3f';
      ctx.fillRect(0, 282, 1024, 60);
      ctx.fillStyle = '#1b1b1b';
      ctx.font = 'bold 92px Impact, "Arial Black", sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('YOUR AD HERE', 512, 150);
      ctx.font = 'bold 44px Arial, sans-serif';
      ctx.fillText(`${area.toUpperCase()} · TROTRO RUN`, 512, 230);
      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 30px Arial, sans-serif';
      ctx.fillText('Advertise on this billboard', 512, 322);
    });
    cache.set(key, texture);
  }
  return texture;
}
